import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/intelliport/sensors';

export default new class IntelliportModel {

  constructor() { }

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(parkingLocationId = null) {
    var filter = { order: ["pid ASC"] };
    if (parkingLocationId) {
      filter = _.merge(filter, { where: { and: [{ carpark_id: parkingLocationId }] } });
    }
    return new Promise((resolve, reject) => {

      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          ParkinglocationModel.getAll(true)
            .then((pl) => {
              let data = [];
              response.data.map(async (child, idx) => {
                let location = _.find(pl, { id: child.carpark_id });
                location
                  ? data.push(Object.assign({}, child, { parkingLocationName: location.Code + ' - ' + location.Name }))
                  : data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
              });
              resolve(data);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  update(id, data) {
    if (data.id !== undefined) {
      delete data.id;
    }
    return new Promise((resolve, reject) => {
      axios.patch(BASE + '/' + id, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

}


// WEBPACK FOOTER //
// ./src/components/IntelliportSensorsModel.js